export const testimonialsAws = [
  {
    quote:
      "Our customers are asking for business-focused guidance on their digital transformation journey. By moving away from the traditional delivery models, iCXeed fills a gap by working backwards from the customer, and ensuring the right foundations (tech, people, process) are in place to deliver differentiated customer value and continuous CX innovation.",
    author: "Andrew Jeffree",
    role: "Customer Experience (CXE) Partner Specialist,ANZ",
    company: "andyjeff@amazon.com",
    image:
      "https://www.icxeed.ai/wp-content/themes/icxeed-website-2025/portal-assets/images/testimonials/andrew-jeffree.png",
  },
  {
    quote:
      "iCXeed is a truly customer-obsessed Amazon Connect partner who will drive engagement all the way from presales to delivery and beyond. Their deep domain expertise, ability to impress both business and technical stakeholders and cost-effective offerings mean that they are an ideal partner for any SMB & Enterprise Amazon Connect customer or organisation that is new to AWS.",
    author: "Victoria Webster",
    role: "Senior CX Sales Specialist",
    company: "vlweb@amazon.com",
    image:
      "https://www.icxeed.ai/wp-content/themes/icxeed-website-2025/portal-assets/images/testimonials/victoria-webster.png",
  },
  {
    quote:
      "Arthur and Ryan are one of the best Amazon Connect delivery partners in Australia. They excel at getting senior leadership to see the vision of AI-powered customer experiences. I 100% would put them in front of a C-Suite and let them work their magic.",
    author: "Kieran Guan",
    role: "Solutions Architect, SMB",
    company: "kguan@amazon.com",
    image:
      "https://www.icxeed.ai/wp-content/themes/icxeed-website-2025/portal-assets/images/testimonials/kieran-guan.png",
  },
  {
    quote:
      "iCXeed's deep contact centre expertise, coupled with their innovative AWS solutions delivery, has been brilliant. Their ability to operationalise complex customer experience programs whilst maximising AWS services at competitive rates sets them apart in the ANZ market.",
    author: "Max Tennant",
    role: "Amazon Connect, Public Sector, ANZ",
    company: "mft@amazon.com",
    image:
      "https://www.icxeed.ai/wp-content/themes/icxeed-website-2025/portal-assets/images/testimonials/max-tennant.png",
  },
  {
    quote:
      "iCXeed is a partner who just delivers. From early engagement through to delivery, they get the job done with no fuss and, more importantly, a high-quality outcome for our Amazon Connect Customers",
    author: "Douglas Park",
    role: "Senior Solutions Architect, APAC",
    company: "parkdoug@amazon.com",
    image:
      "https://www.icxeed.ai/wp-content/themes/icxeed-website-2025/portal-assets/images/testimonials/douglas-park.png",
  },
  {
    quote:
      "I want to express my gratitude to iCXeed for their outstanding support of RecoveriesCorp's innovation initiatives. Ryan and Arthur demonstrated exceptional skill in building trust and rapport with the customer. Their expertise and dedication will help overcome any challenges in securing AWS solutions. I strongly recommend iCXeed as a trusted partner for contact centre migration and innovation projects.",
    author: "Linling Lu",
    role: "Account Manager, ANZ ",
    company: "linlingh@amazon.com",
    image:
      "https://www.icxeed.ai/wp-content/themes/icxeed-website-2025/portal-assets/images/testimonials/linling-lu.png",
  },
  {
    quote:
      "iCXeed has been a truly outstanding partner to work with, they always go the extra mile and really align with our Customer Obsession Leadership principle. Ryan and the team have delivered some truly impressive, customised demos to my customers that demonstrate a deep understanding of the customers' challenges, and they have been able to move rapidly to accelerate deals with customers that are typically slow to move.",
    author: "Jack Shaddock",
    role: "Account Executive, Higher Education",
    company: "ishadd@amazon.com ",
    image:
      "https://www.icxeed.ai/wp-content/themes/icxeed-website-2025/portal-assets/images/testimonials/jack-shaddock.png",
  },
  {
    quote:
      "iCXeed has closely collaborated with the APJ Industry & Partner Solutions team to include AWS' Data & AI services in their innovative offering, CX Perspectives. The offering will help SMB organisations elevate customer experiences to the next level.",
    author: "Sean Mathieson",
    role: "APJ Partner Development Specialist - Data & A",
    company: "seanjm@amazon.com",
    image:
      "https://www.icxeed.ai/wp-content/themes/icxeed-website-2025/portal-assets/images/testimonials/sean-mathieson.png",
  },
  {
    quote:
      "iCXeed has the technical depth, industry knowledge, and business acumen needed to be a successful Amazon Connect partner.  iCXeed is a partner we willingly invest our time in for joint success with Amazon Connect.",
    author: "Kahu Tawhai",
    role: "Head of Solution Architecture, CXE",
    company: "kahut@amazon.com",
    image:
      "https://www.icxeed.ai/wp-content/themes/icxeed-website-2025/portal-assets/images/testimonials/kahu-tawhai.png",
  },
  {
    quote:
      "In a sea of GenAI solutions, iCXeed stands apart by truly understanding Higher Education's DNA. They've mastered the art of turning AWS building blocks into revolutionary student experiences",
    author: "Nils De Vries",
    role: "Principal Solutions Architect",
    company: "nilsvrie@amazon.com  ",
    image:
      "https://www.icxeed.ai/wp-content/themes/icxeed-website-2025/portal-assets/images/testimonials/nils-vries.png",
  },
  {
    quote:
      "I really appreciate the expertise and experience that iCXeed brings to our customer engagements – they have a unique skillset that draws from their experience in running contact centres through their BPO business that adds credibility and reliability to their technology sales engagements. This usually results in customers building trust quickly and establishing a strong engagement early.",
    author: "Mark Hannan",
    role: "Principal Amazon Connect Sales Specialist",
    company: "mhannan@amazon.com",
    image:
      "https://www.icxeed.ai/wp-content/themes/icxeed-website-2025/portal-assets/images/testimonials/douglas-hannan.png",
  },
  {
    quote:
      "iCXeed stands out as a partner who truly lives the principles of customer obsession and high standards. Working with them has been seamless, innovative, and impactful for our customers.",
    author: "Elias Sayigh",
    role: "Solution Architect, Amazon Connect",
    company: "sayelias@amazon.com",
    image:
      "https://www.icxeed.ai/wp-content/themes/icxeed-website-2025/portal-assets/images/testimonials/elias-sayigh.png",
  },
  {
    quote:
      "iCXeed are a collaborative and trusted partner with expertise in not only Connect but also bringing to life AI use cases as demonstrated on RecoveriesCorp MAP 2.0 engagement. Ryan and the iCXeed team are professional and easy to work with, would recommend for your Connect projects",
    author: "Michelle Ng",
    role: "Migration & Modernisation Business Development Manager",
    company: "michkng@amazon.com",
    image:
      "https://www.icxeed.ai/wp-content/themes/icxeed-website-2025/portal-assets/images/testimonials/michelle-ng.png",
  },
];
